import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  ImportRuleQuerySchema,
  ImportRuleResponseSchema,
  ImportRuleSchema,
} from '../shared/schemas/importRuleSchema.js';

export const createImportRule = defaultClient.mutation({
  url: 'omni-connector/auto-import-rule/' as const,
  method: 'POST',
  requestSchema: ImportRuleSchema,
  responseSchema: ImportRuleResponseSchema,
  processResponse: (data) => {
    return data;
  },
  onSuccess: (queryClient) => {
    getImportRuleList.invalidateAll(queryClient, {});
  },
});

export const getImportRuleList = defaultClient.query({
  url: 'omni-connector/auto-import-rule/list' as const,
  method: 'GET',
  responseSchema: ImportRuleResponseSchema,
  querySchema: ImportRuleQuerySchema,
  snakeCaseQueryParams: true,
  processResponse: (data) => {
    return data?.data?.items?.[0] ?? null;
  },
});

export const patchImportRule = defaultClient.mutation({
  url: 'omni-connector/auto-import-rule/$id' as const,
  method: 'PATCH',
  requestSchema: ImportRuleSchema,
  responseSchema: ImportRuleResponseSchema,
  processResponse: (data) => {
    return data;
  },
  onSuccess: (queryClient) => {
    getImportRuleList.invalidateAll(queryClient, {});
  },
});

export const deleteImportRule = defaultClient.mutation({
  url: 'omni-connector/auto-import-rule/$id' as const,
  method: 'DELETE',
  responseSchema: z.string(),
  processResponse: (data) => {
    return data || '';
  },
  onSuccess: (queryClient) => {
    getImportRuleList.invalidateAll(queryClient, {});
  },
});

export type ImportRuleRequestSchema = z.infer<typeof ImportRuleSchema>;
export type ImportRuleResponseSchema = z.infer<typeof ImportRuleResponseSchema>;
